import Vue from 'vue'
import Router from 'vue-router'
import SignIn from '@/pages/SignIn'
import Calendar from '@/pages/Calendar/Calendar'
import Event from '@/pages/Events/Event'
import EventAdd from '@/pages/Events/EventAdd'
import EventEdit from '@/pages/Events/EventEdit'
import Fixture from '@/pages/Fixtures/Fixture'
import Teams from '@/pages/Teams/Teams'
import TeamShow from '@/pages/Teams/TeamShow'
import TeamAdd from '@/pages/Teams/TeamAdd'
import TeamEdit from '@/pages/Teams/TeamEdit'
import PlayerAdd from '@/pages/Players/PlayerAdd'
import FixtureAdd from '@/pages/Fixtures/FixtureAdd'
import FixtureEdit from '@/pages/Fixtures/FixtureEdit'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar
    },
    {
      path: '/event/:id',
      name: 'Event',
      component: Event
    },
    {
      path: '/event/add',
      name: 'EventAdd',
      component: EventAdd
    },
    {
      path: '/event/:id/edit',
      name: 'EventEdit',
      component: EventEdit
    },
    {
      path: '/event/add/:parentid&:competitionid',
      name: 'EventAddWithParent',
      component: EventAdd
    },
    {
      path: '/fixture/add/:eventid',
      name: 'FixtureAdd',
      component: FixtureAdd
    },
    {
      path: '/fixture/edit/:id',
      name: 'FixtureEdit',
      component: FixtureEdit
    },
    {
      path: '/fixture/:id',
      name: 'Fixture',
      component: Fixture
    },
    {
      path: '/teams',
      name: 'Teams',
      component: Teams
    },
    {
      path: '/team/add',
      name: 'TeamAdd',
      component: TeamAdd
    },
    {
      path: '/team/:id',
      name: 'TeamShow',
      component: TeamShow
    },
    {
      path: '/team/:id/edit',
      name: 'TeamEdit',
      component: TeamEdit
    },
    {
      path: '/players/add/:team&:name',
      name: 'PlayerAdd',
      component: PlayerAdd
    },
    {
      path: '/sign-in',
      name: 'SignIn',
      component: SignIn
    },

    { path: '*', redirect: '/teams' }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/sign-in']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('user')

  if (authRequired && !loggedIn) {
    return next('/sign-in')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js